import * as d3 from 'd3';
import * as data from './data';

export function drawSVG ()  {
  var svg_scatter = d3.select("svg[id='chart']");
  svg_scatter.selectAll("*").remove();

  var div_container_element = document.getElementById("chart-container")

  var dataset = data.dataSetCounts(),
    tick_dates = data.tickDates(),
    dataset_length = data.dataSetLength(),
    time_format = data.tickTimeFormat(),
    tick_size = data.tickSize(),
    width = 550,
    height = 320,
    padding = 55,
    radius = 5,
    grid_dataset = data.gridDataSet(),
    start_date = data.startDate(),
    end_date = data.endDate(),
    scale_max = data.scaleMax();

  if (div_container_element != null) {
    width = Math.max(div_container_element.offsetWidth, 300)
    height = div_container_element.offsetHeight - 5
  }

  var xScale = d3.scaleLinear()
                 .domain([start_date, end_date])
                 .range([padding, width - padding]);

  var yScale = d3.scaleLinear()
                 .domain([0, scale_max])
                 .range([height - padding, 40]);

  var gridXScale = d3.scaleLinear()
                .domain([1, dataset_length])
                .range([padding, width - padding]);

  var gridYScale = d3.scaleLinear()
                .domain([0, 1])
                .range([height - padding, 40]);

  var origin = [gridXScale(1), yScale(0)]
  var xaxis_max = [gridXScale(dataset.length), yScale(0)]
  var connector_dataset = [];
  for (var i = 0; i < dataset_length; i++) {
    connector_dataset.push([gridXScale(i + 1), yScale(dataset[i])])
  }

  svg_scatter.selectAll("line[class=grid]")
    .data(grid_dataset)
    .enter()
    .append("line")
    .attr("class", "grid")
    .attr("x1", function(d) {
      return gridXScale(d.x1);
    })
    .attr("y1", function(d) {
      return gridYScale(d.y1);
    })
    .attr("x2", function(d) {
      return gridXScale(d.x2);
    })
    .attr("y2", function(d) {
      return gridYScale(d.y2);
    });

  var lineGenerator= d3.line().curve(d3.curveMonotoneX);
  var chartString = lineGenerator(connector_dataset);
  var shadeString = `M${origin[0]},${origin[1]}L` + chartString.substr(1) + `L${xaxis_max[0]},${xaxis_max[1]}`
  svg_scatter.append('path')
  .attr("class", "shade")
  .attr('d', shadeString);

  var connectorString = lineGenerator(connector_dataset)
  svg_scatter.append('path')
  .attr("class", "connector")
  .attr('d', connectorString);

  var time_formatter = d3.timeFormat(time_format)
 
  var xAxis = d3.axisBottom(xScale);
  xAxis.ticks(dataset_length)
      .tickValues(tick_dates)
      .tickSize(tick_size)
      .tickFormat(function(d) {
        if (data.tickJump() === 'month') {
          if (width > 500) {
            return time_formatter(d)
          } else {
            return time_formatter(d).substring(0, 1)
          }
        } else {
          if (width > 400) {
            return time_formatter(d)
          } else {
            return time_formatter(d).substring(0, 1)
          }
        }
      });

  var yAxis = d3.axisLeft(yScale)
      .tickFormat(function(d) {
        if (d >= 10) {
          return d3.format('.2s')(d);
        } else {
          return d;
        }
      })
      .tickValues([0, scale_max * (1/5), scale_max * (2/5), scale_max * (3/5), scale_max * (4/5), scale_max]);

  svg_scatter.append("g")
             .attr("class", "axis bottom")
             .attr("transform", "translate(0," + (height - padding) + ")")
             .call(xAxis);

  svg_scatter.selectAll(".axis.bottom text")
             .attr("transform", "translate(0," + radius + ")");

  svg_scatter.append("g")
            .attr("class", "axis left")
            .attr("transform", "translate(" + padding + ",0)")
            .call(yAxis);

  svg_scatter.selectAll(".axis.left text")
            .attr("transform", "translate(" + -radius + ",0)");

  svg_scatter.append("text")
      .attr("class", "x label")
      .attr("text-anchor", "middle")
      .attr("x", (width / 2) + 0)
      .attr("y", height - 10)
      .text(data.xAxisLabel());

  svg_scatter.append("text")
      .attr("class", "y label")
      .attr("text-anchor", "middle")
      .attr("transform", "rotate(-90)")
      .attr("x", - height / 2)
      .attr("y", 10)
      .text(data.yAxisLabel());

  

  var box_width;
  if (dataset_length > 1) {
   box_width = (width - (2 * padding)) / (dataset_length - 1);
  } else {
    box_width = (width - (2 * padding)) * 2
  }

  var format = d3.timeFormat(data.tickDateLabelFormat());
  var data_label_dates = data.dataLabelDates();

  for (var i = 0; i < dataset_length; i++) {
    var rectangle = svg_scatter.append("g")
      .attr("class", "rect");

    rectangle.append("rect")
      .attr("class", "hover-detector")
      .attr("x", padding + (box_width * (i - 0.5)))
      .attr("y", 5)
      .attr("width", box_width)
      .attr("height", height - padding - 5);

    rectangle.append("line")
      .attr('x1', padding + (box_width * i))
      .attr('y1', 30)
      .attr('x2', padding + (box_width * i))
      .attr('y2', height - padding);

    rectangle.append("rect")
      .attr("class", "label-border")
      .attr("x", padding + (box_width * i) - 35)
      .attr("y", 0)
      .attr("width", 70)
      .attr("height", 35);

    rectangle.append("text")
      .attr("class", "date-label")
      .attr("text-anchor", "middle")
      .attr("x", padding + (box_width * i))
      .attr("y", 13)
      .text(format(data_label_dates[i]));

    var count_datum;
    if (dataset[i] >= 10) {
      count_datum = d3.format('.2s')(dataset[i]);
    } else {
      count_datum = dataset[i];
    }

    rectangle.append("text")
      .attr("class", "count")
      .attr("text-anchor", "middle")
      .attr("x", padding + (box_width * i))
      .attr("y", 28)
      .text(count_datum);

    rectangle.append("circle")
      .attr("cx", padding + (box_width * i))
      .attr("cy", yScale(dataset[i]));

  }
}